<div class="container">
  <h1 class="title">{{'locker.box.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="openNewBox()"><mat-icon>add</mat-icon></button>

  <mat-card>
    <app-filter [filters]="fieldFilters" [massiveAccions]="massiveAccions" btLabel="Buscar"
      (submit)="searchBoxes()" (massiveAction)="onClickMassiveAction($event)"
      (massiveActionChanged)="onChangeMassiveActionSelected($event)"></app-filter>
  </mat-card>

  <div class="table-container">
    <app-data-table
      preset="admin"
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [selectionColumn]="selectionColumnConfig"
      [showPaginator]="true"
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[25, 50, 100]"
      [rowClickable]="true"
      [rowClass]="lockerRowClass"
      tableClass="mat-elevation-z1"
      (rowClick)="openDetails($event.row)"
      (selectionToggleAll)="masterToggle()"
      (selectionToggleRow)="selection.toggle($event)"
      (page)="onPageChange($event)">
      <ng-container matColumnDef="lockerNumber">
        <th mat-header-cell *matHeaderCellDef>{{'locker.box.table.header.lockerId'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.lockerNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="key">
        <th mat-header-cell *matHeaderCellDef>{{'locker.box.table.header.key'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.category?.code }}</td>
      </ng-container>

      <ng-container matColumnDef="doorBox">
        <th mat-header-cell *matHeaderCellDef>{{'locker.box.table.header.doorBox'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">
          <app-data-table-badge
            [label]="element.doorBox"
            [icon]="getDoorBoxIcon(element.doorBox)"
            [tone]="getDoorBoxTone(element.doorBox)">
          </app-data-table-badge>
        </td>
      </ng-container>

      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>{{'locker.box.table.header.channel'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">
          <app-data-table-badge
            [label]="element.channel|traduccion"
            [icon]="getChannelIcon(element.channel)"
            [tone]="getChannelTone(element.channel)">
          </app-data-table-badge>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-flat-button color="warn" type="button" (click)="openDoor(element); $event.stopPropagation()">
            {{'locker.box.table.header.action'|traduccion}}
          </button>
        </td>
      </ng-container>
    </app-data-table>
  </div>
</div>
